import { evidenceCases } from '@/mocks/collections';
import SectionHead from './Section';

const statusStyle: Record<string, string> = {
  实锤: 'bg-flame-500 text-white',
  争议: 'bg-gold-500 text-ink-950',
  存证中: 'bg-paper-200 text-ink-700',
};

export default function EvidenceSection() {
  const kinds: Record<string, number> = {};
  evidenceCases.forEach((c) => c.kinds.forEach((k) => (kinds[k] = (kinds[k] || 0) + 1)));
  const typeList = [
    { label: '实拍画面', n: kinds['实拍画面'] || 0 },
    { label: '录音转写', n: kinds['原声切片'] || 0 },
    { label: '聊天截图', n: kinds['群聊公告'] || 0 },
    { label: '日程比对', n: kinds['行程比对'] || 0 },
  ];

  return (
    <section id="hammer" className="bg-paper-50 py-10 md:py-14 scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <SectionHead
          kicker="实锤合集 · EVIDENCE INDEX"
          title="证据整理中心"
          desc="不打口水仗，只摆材料。这里按涉事人物归档每一桩事件的实锤合集与证据整理进度，方便一页速览、逐案深挖。"
          link="#media"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[320px_1fr]">
          {/* 左：索引说明卡 */}
          <aside className="lg:sticky lg:top-20 lg:self-start">
            <div className="rounded-xl border border-paper-200 bg-paper-100 p-5">
              <h3 className="flex items-center gap-2 font-display text-lg font-black text-ink-950">
                <i className="ri-folder-3-fill text-flame-500" />
                归档说明
              </h3>
              <p className="mt-3 text-sm leading-6 text-ink-600">
                每一份合集都保留可回溯的原始素材。绿色系标记已定性的「实锤」，黄色为证据仍在争议，灰色为线索待补全的「存证中」。
              </p>
              <ul className="mt-4 space-y-2 text-sm">
                {typeList.map((t) => (
                  <li key={t.label} className="flex items-center justify-between rounded-lg bg-paper-50 px-3 py-2">
                    <span className="text-ink-700">{t.label}</span>
                    <b className="font-display text-base text-flame-600">{t.n}</b>
                  </li>
                ))}
              </ul>
              <a
                href="#latest"
                className="mt-4 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ink-900 px-4 py-2.5 text-sm font-bold text-paper-50 hover:bg-ink-950"
              >
                了解归档规则
                <i className="ri-arrow-right-line" />
              </a>
            </div>
            <div className="mt-4 overflow-hidden rounded-xl bg-ink-950 p-5 text-paper-50">
              <p className="text-xs font-bold tracking-[0.25em] text-gold-300">本周实锤战报</p>
              <p className="mt-3 font-display text-3xl font-black text-flame-400">+47 条</p>
              <p className="mt-1 text-sm text-paper-200/80">新增被归档的可信证据</p>
            </div>
          </aside>

          {/* 右：索引表 */}
          <div className="overflow-hidden rounded-xl border border-paper-200 bg-paper-50">
            <div className="flex items-center justify-between border-b border-paper-200 bg-paper-100/60 px-4 py-3 text-xs font-bold text-ink-500 md:px-5">
              <span>涉事人物 / 事件</span>
              <span className="hidden md:inline">证据构成</span>
              <span className="hidden lg:inline">状态</span>
              <span>讨论</span>
            </div>
            <ul className="divide-y divide-paper-100">
              {evidenceCases.map((c) => (
                <li
                  key={c.id}
                  className="group flex cursor-pointer flex-wrap items-center gap-3 px-4 py-4 transition-colors hover:bg-flame-50/60 md:px-5"
                >
                  <div className="flex min-w-0 flex-1 items-center gap-3">
                    <span className="grid h-7 w-7 shrink-0 place-items-center rounded-md bg-paper-200 font-display text-sm font-black text-ink-700">
                      {c.id.toUpperCase().slice(1)}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate font-bold text-ink-950 group-hover:text-flame-700">{c.person}</p>
                      <p className="truncate text-xs text-ink-500">{c.matter}</p>
                    </div>
                  </div>

                  <div className="hidden flex-none flex-col items-end gap-1 md:flex">
                    <div className="flex flex-wrap justify-end gap-1">
                      {c.kinds.map((k) => (
                        <span key={k} className="rounded bg-paper-100 px-1.5 py-0.5 text-[10px] text-ink-600">
                          {k}
                        </span>
                      ))}
                    </div>
                    <span className="text-[11px] font-bold text-gold-600">{c.evCount} 条证据素材</span>
                  </div>

                  <div className="hidden flex-none lg:block">
                    <span className={`inline-block whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-black ${statusStyle[c.status]}`}>
                      {c.status}
                    </span>
                  </div>

                  <div className="flex flex-none flex-col items-end gap-1 text-xs text-ink-500">
                    <span className="flex items-center gap-1 font-bold text-ink-700">
                      <i className="ri-chat-3-line text-flame-500" />
                      {c.discuss}
                    </span>
                    <span>{c.updated}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}